/*
 *
 * Header / Menu
 *
 */

import Headroom from 'headroom.js';



/* SLIDE UP */
let slideUp = (target, duration=500) => {

    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
          target.style.display = 'none';
          target.style.removeProperty('height');
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
          //alert("!");
    }, duration);
}

/* SLIDE DOWN */
let slideDown = (target, duration=500) => {

    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
}

/* TOOGLE */
const slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
      return slideDown(target, duration);
    } else {
      return slideUp(target, duration);
    }
}






$(document).ready(() => {

  // Headroom
  var headerBanner = document.getElementById('header');
  var options = {
    tolerance : 16,
  };
  var headroom  = new Headroom(headerBanner, options);

  headroom.init();



  // Hamburger Menu Show/Hide
  const menuButton = document.querySelector("#main-nav-btn");

  menuButton.addEventListener("click", () => {
    document.body.classList.toggle("menu-visible");
    menuButton.classList.toggle("menu-close");

    if ( document.body.classList.contains("menu-visible") ) {
      document.body.style =
        "overflow-y:hidden; position: relative; margin-right: var(--widthReflow);";
    } else {
      document.body.style =
        "overflow-y:visible; position: static; margin-right: 0;";
    }
  });

  // Menu toggle sub-menu
  const subMenuBtns = document.getElementsByClassName("sub-menu-btn");

  var toggleSubMenu = function(e) {
    const parent = e.currentTarget.parentNode;
    parent.classList.toggle("menu-visible");
    slideToggle(parent.querySelector(".sub-menu") , 250);
  };

  for (var i = 0; i < subMenuBtns.length; i++) {
    subMenuBtns[i].addEventListener('click', toggleSubMenu, false);
  }

});
